import styles from './Header.module.css';
import { HamburgerMenu } from '../HamburgerMenu/HamburgerMenu';

export function Header() {
  return (
    <header className={styles.header}>
      <div className={styles.container}>
        <HamburgerMenu />
        <img src="/logo.png" alt="REFUGE" className={styles.logo} />
        <a
          href="https://www.instagram.com/refuge.nyc"
          target="_blank"
          rel="noopener noreferrer"
          className={styles.socialLink}
          aria-label="Follow us on Instagram"
        >
          <svg
            width="24"
            height="24"
            viewBox="0 0 24 24"
            fill="none"
            stroke="currentColor"
            strokeWidth="2"
            strokeLinecap="round"
            strokeLinejoin="round"
          >
            <rect x="2" y="2" width="20" height="20" rx="5" ry="5"></rect>
            <path d="M16 11.37A4 4 0 1 1 12.63 8 4 4 0 0 1 16 11.37z"></path>
            <line x1="17.5" y1="6.5" x2="17.51" y2="6.5"></line>
          </svg>
        </a>
      </div>
    </header>
  );
}
